import DOMPurify from "dompurify";
import React, { FC } from "react";
import { mapMessages } from "shared/mapMessages";
import { useIntl } from "react-intl";

const messages = mapMessages("shared.components.SiteCustomisation", {
    opensInNewTab: "(opens in a new tab)",
});

interface IProps {
    value: string | null;
    className?: string;
}

export const SiteCustomisation: FC<IProps> = ({ value, className }) => {
    const { formatMessage } = useIntl();

    if (value === null || value === "") {
        return null;
    }

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={createContentMarkup(
                value,
                formatMessage(messages.opensInNewTab)
            )}
            data-testid="SiteCustomisation"
        />
    );
};

function createContentMarkup(content: string, opensInNewTabText: string) {
    const linkHook = (node: Element) => {
        if (node.hasAttribute("href")) {
            node.setAttribute("target", "_blank");
            node.setAttribute("rel", "noopener noreferrer");

            const text = node.textContent ?? "";
            node.setAttribute("aria-label", `${text} ${opensInNewTabText}`.trim());
        }
    };

    DOMPurify.addHook("afterSanitizeAttributes", linkHook);

    const sanitizedContent = DOMPurify.sanitize(content);

    DOMPurify.removeHook("afterSanitizeAttributes");

    return { __html: sanitizedContent };
}
